import linkArrow from '../../../images/link-arrow.png';

export default theme => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        fontFamily: theme.headerFont,
        boxShadow: '0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)'
    },
    header: {
        marginTop: 24,
        color: theme.palette.common.white,
        textAlign: 'center',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        fontSize: 18,
        height: 75,
        [theme.breakpoints.up('md')]: {
            fontSize: 32,
            marginTop: 36,
            letterSpacing: '0.056em',
            lineHeight: 1,
            maxWidth: '80%',
            marginLeft: 'auto',
            marginRight: 'auto',
            height: 98,
        }
    },
    offer: {
        position: 'absolute',
        zIndex: 1,
        top: 0,
        left: '8px',
        padding: '0.5em 1.4em',
        color: theme.palette.primary.light,
        backgroundColor: 'white',
        fontSize: '14px',
        textTransform: 'uppercase',
    },
    image: {
        height: '360px'
    },
    cta: {
        padding: '1em 0',
        color: theme.palette.primary.light,
        fontSize: 16,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        textDecoration: 'none',
        textAlign: 'center',
        borderTop: '1px solid black',

        '&::after': {
            width: '36px',
            height: '13px',
            display: 'inline-block',
            marginLeft: 18,
            backgroundImage: 'url(' + linkArrow + ')',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            content: '""',
            transition: 'margin-left .3s ease-in-out',
        },
    },
    upper: {
        position: 'relative',
        display: 'flex',
        flexGrow: '1',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        borderBottom: '15px solid ' + theme.palette.background.default,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        [theme.breakpoints.up('md')]: {
            borderBottomWidth: 50,
        },
        '& img': {
            position: 'relative',
            zIndex: 1,
            maxWidth: 150,
            margin: '0 auto -20px',
            height: 'auto',
            [theme.breakpoints.up('md')]: {
                marginBottom: -50,
                maxWidth: 360,
            },
        },
    },
    lower: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '0 3em 2em',
        backgroundColor: theme.palette.background.default,
    }
});